
import { defineComponent } from 'vue'
import BaseSeparator from './BaseSeparator.vue'

export default defineComponent({
  components: {
    BaseSeparator,
  },
  props: {
    tag: {
      type: String,
      default: 'li',
    },
  },
})
